<template>
    <div
        v-if="product.canvas_id == canvasId"
        class="cart-item-personalized mb-2"
        :class="{ 'd-flex flex-justify-between flex-align-center margin-cart': isCartPage }"
    >
        <div>
            {{ cartProductName(product) }}
            <div class="d-flex flex-align-center mt-1">
                <div
                    class="color-personalized-badge mr-2"
                    :style="{
                        'background-color': product.product_color_hexa,
                        border:
                            product.product_color_hexa === '#ffffff' ? '1px solid black' : 'none',
                    }"
                ></div>
                {{ product.product_color_name }}
            </div>
        </div>

        <div class="d-flex">
            <div class="d-flex flex-align-center">
                <i
                    class="icon-cr icon-less icon-cr-hover hidden-md-down"
                    title="Retirar 1 item"
                    @click="$emit('remove-one')"
                />
                <input
                    :max="null"
                    :value="product.quantity"
                    class="my-0 text-center"
                    type="text"
                    style="max-width: 77px; max-height: 34px"
                    @change="$emit('quantity-change', $event)"
                />
                <i
                    class="icon-cr icon-plus icon-cr-hover hidden-md-down"
                    title="AdicionAdicionar 1 item"
                    @click="$emit('add-one')"
                />
            </div>

            <i
                class="icon-cr icon-trash new-up-icons icon-cr-hover mt-1 ml-2"
                title="Remover itens"
                @click="$emit('remove')"
            />
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CustomizableProductCartItem',

        props: {
            product: {
                type: Object,
                required: true,
            },
            canvasId: {
                type: Number,
                required: true,
            },
            isCartPage: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                productsAlert: null,
            };
        },

        methods: {
            cartProductName(product) {
                return product.product_model_name + ' ' + product.size;
            },
        },
    };
</script>
